import {
  SUPPLIERS_BATCH_DELETE_REQUEST,
  SUPPLIERS_BATCH_DELETE_SUCCESS,
  SUPPLIERS_BATCH_DELETE_FAILURE,
  SUPPLIERS_FETCH_MANY_REQUEST,
  SUPPLIERS_FETCH_MANY_SUCCESS,
  SUPPLIERS_FETCH_MANY_FAILURE,
  SUPPLIERS_FETCH_REQUEST,
  SUPPLIERS_FETCH_SUCCESS,
  SUPPLIERS_FETCH_FAILURE,
  SUPPLIERS_SAVE_REQUEST,
  SUPPLIERS_SAVE_SUCCESS,
  SUPPLIERS_SAVE_FAILURE,

  EMPTY_SUPPLIERS,
  CLEAR_ERRORS
} from './types'

export default {
  deleteMany ({ commit }, { ids = [] }) {
    commit(SUPPLIERS_BATCH_DELETE_REQUEST)
    return window.axios.post('/suppliers', { _method: 'DELETE', ids }).then(response => {
      commit(SUPPLIERS_BATCH_DELETE_SUCCESS, response)
      return response
    }).catch(error => {
      commit(SUPPLIERS_BATCH_DELETE_FAILURE, error)
      throw error
    })
  },
  fetchMany ({ commit }, { query = '', page = 1, extraParams = {} }) {
    commit(SUPPLIERS_FETCH_MANY_REQUEST)
    return window.axios.get('/suppliers', { params: { query, page, ...extraParams } }).then(response => {
      commit(SUPPLIERS_FETCH_MANY_SUCCESS, response)
      return response
    }).catch(error => {
      commit(SUPPLIERS_FETCH_MANY_FAILURE, error)
      throw error
    })
  },
  fetch ({ commit }, id) {
    commit(SUPPLIERS_FETCH_REQUEST)
    return window.axios.get(`/suppliers/${id}`).then(response => {
      commit(SUPPLIERS_FETCH_SUCCESS, response)
      return response
    }).catch(error => {
      commit(SUPPLIERS_FETCH_FAILURE, error)
      throw error
    })
  },
  save ({ commit }, user) {
    const path = user.id ? `/suppliers/${user.id}` : '/suppliers'
    const method = user.id ? 'put' : 'post'

    commit(SUPPLIERS_SAVE_REQUEST)
    return window.axios[method](path, user).then(response => {
      commit(SUPPLIERS_SAVE_SUCCESS, response)
      return response
    }).catch(error => {
      if (error.response.status === 422) {
        commit(SUPPLIERS_SAVE_FAILURE, { validationErrors: error.response.data })
      } else {
        commit(SUPPLIERS_SAVE_FAILURE, { error })
      }
      throw error
    })
  },
  empty({ commit }) {
    commit(EMPTY_SUPPLIERS);
  },
  clearErrors({ commit }) {
    commit(CLEAR_ERRORS)
  }
}
